import { Form, Input, Tooltip } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntBreedingFarmStatus } from "../../../../models/handBooks/breedingFarmStatus";
import { aliasText } from "../../../../utils";

enum FormField {
    nameKy,
    nameRu,
    alias
}
interface IProps {
    show: boolean;
    breedingFarmStatus: EntBreedingFarmStatus;
    onHide: () => void;
    onSubmit: (pos: EntBreedingFarmStatus) => Promise<boolean>;
}

export const AddBreedingFarmStatusModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);


    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.nameKy, value: props.breedingFarmStatus.nameKy },
            { name: FormField.nameRu, value: props.breedingFarmStatus.nameRu },
            { name: FormField.alias, value: props.breedingFarmStatus.alias },
        ]);
    }

    const setEntityFromFields = (): EntBreedingFarmStatus => {
        let breedingFarmStatus = _.cloneDeep(props.breedingFarmStatus);
        breedingFarmStatus.nameKy = form.getFieldValue(FormField.nameKy);
        breedingFarmStatus.nameRu = form.getFieldValue(FormField.nameRu);
        breedingFarmStatus.alias = form.getFieldValue(FormField.alias);
        return breedingFarmStatus;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.breedingFarmStatus.id === 0 ? t('handbooks.phiv_status.add_phiv_status') : t('handbooks.phiv_status.edit_phiv_status')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Tooltip title={aliasText} >
                        <Form.Item
                          label={t('general.alias')}
                          name={FormField.alias}
                          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                        >
                            <Input maxLength={255} showCount autoComplete="off" />
                        </Form.Item>
                    </Tooltip>
                    <Form.Item
                        label={t('general.nameKy')}
                        name={FormField.nameKy}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('general.nameRu')}
                        name={FormField.nameRu}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                </Form>
            </DraggableModal>

        </>

    )
}
